import {StyledFlexContainer} from './styled';
import {IconName} from '@planday-corp/ui/icons/Icon';
import Icon from '@planday-corp/ui/icons/Icon';
import {Color} from '@planday-corp/ui/styles/colors';
import Text from '@planday-corp/ui/text/Text';
import {Label} from '@planday-corp/ui/types';
import {styled} from 'styled-components';

const StyledIcon = styled(Icon)`
  margin-right: 0.5rem;
`;

export default function IconWithText({
  text,
  icon,
  color = 'black',
  className,
}: {
  text: Label;
  icon: IconName;
  color?: Color;
  className?: string;
}) {
  return (
    <StyledFlexContainer className={className}>
      <StyledIcon iconName={icon} color={color} />
      <Text value={text} color={color} />
    </StyledFlexContainer>
  );
}
